export enum AvatarType {
  User = 'user',
  System = 'system',
  Team = 'team',
  Component = 'component',
  Link = 'link',
}
